import { LitElement, css, html, unsafeCSS } from "lit";
import { customElement } from "lit/decorators.js";
import styles from "./styles.css?inline";
import { template } from "./template";
import { connectedProperty } from "../../../../infrastructure/state/connected-property";
import { isAllDataFailedToLoad, selectErrorMessages } from "../selectors";
import { PrimariaApi } from "@uxland/primary-shell";
import { IErrorHistoryItem } from "../../../domain/model";
import { HandleHistoryItemsAddError } from "../handle-history-items-add-error/request";
import { lazyInject } from "../../../../infrastructure/ioc/container";
import { TYPES } from "../../../../infrastructure/ioc/types";

//@ts-ignore
@customElement("activity-history-full-data-error")
export class ActivityHistoryFullDataError extends LitElement {
  render() {
    return html`${template(this)}`;
  }

  static styles = css`
    ${unsafeCSS(styles)}
  `;

  @connectedProperty(isAllDataFailedToLoad)
  isAllDataFailedToLoad: boolean;

  @connectedProperty(selectErrorMessages)
  errorMessages: Array<IErrorHistoryItem> = [];

  @lazyInject(TYPES.primaryApi)
  api: PrimariaApi;

  handleClickFeedback() {
    this.api.broker.send(new HandleHistoryItemsAddError(this.errorMessages));
  }
}
